<template>
  <v-col cols="12"
         class="pa-0">
    <div class="add-button dmb-form-text mt-5"
         @click="$emit('add')" >
      <v-icon class="black87" >add</v-icon>
      <span>{{ text }}</span>
    </div>
  </v-col>
</template>

<script>
export default {
  name: "AddButton",
  props: {
    text: {
      type: String,
      required: true
    }
  }
};
</script>
<style>
.add-button {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.add-button:hover .v-icon, .add-button:hover span {
  color: #0085CF !important;
}
</style>
